import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '../../../Components/index';
import classes from '../create.css';

const Step1 = (props) => {
  const {
    displayResource,
    changeHandler,
    description,
    resource,
    name,
    organization,
    school,
    district,
  } = props;
  return (
    <div className={classes.FormSection}>
      <TextInput
        light
        name="name"
        label={`Titre`}
        change={changeHandler}
        value={name}
        width="100%"
      />
      <TextInput
        light
        name="description"
        label="description"
        change={changeHandler}
        value={description}
        width="100%"
        data-testid={`${resource}-description`}
      />
      {resource === 'courses' ? (
        <div className={classes.FormSection}>
          <div className={classes.OptionalHeader}>
            Informations supplémentaires sur le cours (facultatif)
          </div>
          <TextInput
            light
            name="organization"
            label="Organisation"
            value={organization}
            change={changeHandler}
            width="100%"
            data-testid={`${resource}-organization`}
          />
          <TextInput
            light
            name="district"
            label="District"
            value={district}
            change={changeHandler}
            width="100%"
            data-testid={`${resource}-district`}
          />
          <TextInput
            light
            name="school"
            label="École"
            value={school}
            change={changeHandler}
            width="100%"
            data-testid={`${resource}-school`}
          />
        </div>
      ) : null}
    </div>
  );
};

Step1.propTypes = {
  displayResource: PropTypes.string.isRequired,
  changeHandler: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  district: PropTypes.string,
  school: PropTypes.string,
  organization: PropTypes.string,
};

Step1.defaultProps = {
  district: '',
  school: '',
  organization: '',
};

export default Step1;



// WEBPACK FOOTER //
// ./src/Containers/Create/NewResource/Step1.js